//Library Imports
import { Popover } from "antd";
//Local Imports
import AddMore from "./AddMore";
import AddRoundIcon from "assets/img/icons/addRoundIcon.svg";
import { Trigger } from "../constants";
//Style Imports
import styled from "styled-components";

type Props = {
  triggerType: string;
  actionRefrence: string;
  downline: boolean;
  disabled: boolean;
  hasChildren: boolean;
  scaling: string;
};

const TriggerWorkflow = (props: Props) => {
  const { triggerType, actionRefrence, downline, disabled, hasChildren, scaling } = props;
  const triggerContent = (
    <div style={{ lineHeight: "18px" }}>
      Click on the <img src={AddRoundIcon} alt="" width="17" /> sign to add your first
      <br />
      action
    </div>
  );
  return (
    <Wrapper>
      <div
        title={triggerType + " " + actionRefrence}
        className={`action-wrapper ${scaling === "scaled" ? "zoom-out" : "zoom-in"}`}
      >
        <span className="action-type">{triggerType}</span>
        <span className="action-label">{actionRefrence}</span>
      </div>
      {downline ? <div className="downline"></div> : null}
      {downline ? (
        <Popover
          placement="bottomLeft"
          content={triggerContent}
          getPopupContainer={() => document.querySelectorAll(".workflow-container")[0] as HTMLElement}
          trigger="hover"
          overlayClassName="workflow-popover"
        >
          <span className="trigger-add-more">
            <AddMore id={Trigger} disabled={disabled} hasChildren={hasChildren} />
          </span>
        </Popover>
      ) : null}
    </Wrapper>
  );
};

export default TriggerWorkflow;

const Wrapper = styled.div`
  display: block;
  text-align: center;
  clear: both;
  margin: 0 30px;
  .action-wrapper {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 9px 14px;
    border: 1px solid #7e7e7e;
    display: inline-block;
    margin: 0 auto;
    /* white-space: nowrap; */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
      padding: 6px 10px;
    }
    &.disabled {
      opacity: 0.3;
      pointer-events: none;
    }
    &.zoom-out {
      border: 2px solid #7e7e7e;
    }
    span {
      color: #001823;
      font-size: 16px;
      font-family: "Roboto", sans-serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
      &.action-type {
        font-weight: 700;
        margin-right: 5px;
      }
      &.action-label {
        font-weight: 500;
      }
    }
  }
  .downline {
    background-color: #979797;
    width: 2px;
    height: 25px;
    margin: 0 auto;
  }
  .trigger-add-more {
    display: inline-block;
  }
`;
